const C = require("../constants");

const listProductStock = products_stock => {
    return {
        type: C.PRODUCTS_STOCK,
        products_stock
    }
};

const updateProductStock = product_stock => {
    return {
        type: C.PRODUCTS_STOCK_UPDATE,
        product_stock
    }
};

export {
    listProductStock,
    updateProductStock
};


// WEBPACK FOOTER //
// ./src/actions/ProductStockActions.js